/**
 * @generated SignedSource<<f85c702e2ddc54383bcfa4ba4706b9c0>>
 * @relayHash 4b95665958870d4e08600508e3255f7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 685edb442232e0bac516826991501285e77f6e5637793ccc0f1c9256bf3efd06

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOBoardPerformanceSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOBoardPerformanceStatus = "FAST" | "MODERATE" | "SLOW" | "%future added value";
export type JiraCFOFilterOperator = "CONTAINS" | "ENDS_WITH" | "EQUALS" | "IN" | "IS_NOT_NULL" | "IS_NULL" | "NOT_EQUALS" | "NOT_IN" | "STARTS_WITH" | "%future added value";
export type JiraCFOSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOFilterInput = {
  boardFilter?: JiraCFOBoardFilterInput | null;
  dimensionFilter?: JiraCFODimensionFilterInput | null;
};
export type JiraCFOBoardFilterInput = {
  creatorAccountId?: ReadonlyArray<string> | null;
  keyword?: string | null;
  performanceStatus?: ReadonlyArray<JiraCFOBoardPerformanceStatus | null> | null;
  sortInput?: ReadonlyArray<JiraCFOBoardPerformanceSortInput | null> | null;
};
export type JiraCFOBoardPerformanceSortInput = {
  key?: string | null;
  order?: JiraCFOBoardPerformanceSortOrder | null;
};
export type JiraCFODimensionFilterInput = {
  name: string;
  operator: JiraCFOFilterOperator;
  values: ReadonlyArray<string>;
};
export type JiraCFOSortInput = {
  key?: string | null;
  order?: JiraCFOSortOrder | null;
};
export type BoardPerformanceTabV2Query$variables = {
  after?: string | null;
  cloudId: string;
  endDate: AGG$DateTime;
  filters?: ReadonlyArray<JiraCFOFilterInput> | null;
  sortInput?: ReadonlyArray<JiraCFOSortInput | null> | null;
  startDate: AGG$DateTime;
};
export type BoardPerformanceTabV2Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardPerformanceTabSummaryV2" | "BoardPerformanceTabTableV2">;
};
export type BoardPerformanceTabV2Query = {
  response: BoardPerformanceTabV2Query$data;
  variables: BoardPerformanceTabV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortInput"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v11 = {
  "kind": "Variable",
  "name": "sortInput",
  "variableName": "sortInput"
},
v12 = {
  "kind": "Literal",
  "name": "dimensions",
  "value": [
    {
      "alias": "jira_board_id",
      "name": "custom:boardId"
    }
  ]
},
v13 = {
  "kind": "Literal",
  "name": "isV2",
  "value": true
},
v14 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": {
        "type": "SUM"
      },
      "alias": "views",
      "name": "count"
    },
    {
      "aggregation": {
        "type": "PERCENTILE",
        "value": 0.75
      },
      "alias": "loadTime",
      "name": "vc90"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "slowBoardThreshold"
},
v17 = {
  "kind": "ScalarField",
  "name": "fastBoardThreshold"
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v19 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "self"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BoardPerformanceTabV2Query",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabSummaryV2"
      },
      {
        "args": [
          (v9/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabTableV2"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BoardPerformanceTabV2Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "boardPerformanceSummary",
            "args": [
              (v6/*: any*/),
              (v12/*: any*/),
              (v7/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moderateBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardsCount"
                          },
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "after",
                    "value": ""
                  },
                  (v18/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ],
                "storageKey": "data(after:\"\",first:25)"
              }
            ]
          },
          {
            "alias": "boardPerformanceTableValuesV2",
            "args": [
              (v6/*: any*/),
              (v12/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v11/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              },
              {
                "args": [
                  (v9/*: any*/),
                  (v18/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraBoardLocationModel",
                                "kind": "LinkedField",
                                "name": "boardLocation",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "userLocationId"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "projectKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "perfStatus"
                              },
                              {
                                "concreteType": "JiraBoardAdmins",
                                "kind": "LinkedField",
                                "name": "boardAdmins",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraBoardAdminUser",
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "active"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "accountId"
                                      },
                                      {
                                        "concreteType": "JiraBoardAdminAvatarUrls",
                                        "kind": "LinkedField",
                                        "name": "avatarUrls",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "xsmall"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "small"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "medium"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "large"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraBoardAdminGroup",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": true,
                                    "selections": [
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraCFOBoardPerformanceDataRow"
                          }
                        ]
                      }
                    ]
                  },
                  (v19/*: any*/),
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "685edb442232e0bac516826991501285e77f6e5637793ccc0f1c9256bf3efd06",
    "metadata": {},
    "name": "BoardPerformanceTabV2Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5fe8fba112b0ffefe41c1d7bb7e7ea4c";

export default node;
